import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef } from "react";
import Header from '../components/Header';
import { BsCalendar4Week, BsSearch, BsFillPinMapFill } from "react-icons/bs";
import Sheet from 'react-modal-sheet';
import { ko } from "date-fns/locale";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import NoData from "../components/NoData";
import Product5 from "../components/Product5";
import { useAxios } from "../services/useAxios";
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import DelivManagement from "./DelivManagement"
import {alert, confirm} from "../components/MegConfirmAlert";
import { useDaumPostcodePopup } from 'react-daum-postcode';
import Nav from 'react-bootstrap/Nav';
import Nodata from "../components/NoData";


export default function MilegeHistory() {
    const { t } = useTranslation();
    const [request] = useAxios();
    const { control }= useForm();
    const [isOpen, setOpen] = useState(false);

    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    
    const [page, setPage] = useState(0);

    const [selectType, setSelectType] = useState("");


    const open = useDaumPostcodePopup();
    let now = new Date();
    const [srchStartDt, setSrchStartDt] = useState(new Date(now.setMonth(now.getMonth()-1)));
    const [srchEndDt, setSrchEndDt] = useState(new Date());
    const [month, setMonth] = useState('0');

    const fn_checkMonth = (e) => {
        setMonth(e.target.value);
        if(e.target.value === '0'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-1)));
            setSrchEndDt(new Date());
        }else if(e.target.value === '1'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-3)));
            setSrchEndDt(new Date());
        }else if(e.target.value === '2'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-6)));
            setSrchEndDt(new Date());
        }else if(e.target.value === '3'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-12)));
            setSrchEndDt(new Date());
        }
        
    }

    const fetchData = async (pageIndex) => {
        const response = await request.post("/app/mypage/getMyMileageListAPI", {
            srchStartDt : srchStartDt,
            srchEndDt :srchEndDt,
            type:selectType,            
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){         
            console.log(response.data.result)  
            setData(response.data.result);       
            if(pageIndex ===1){
                setDataList(response.data.result.mlgAccmlList);
            }else{
                setDataList((prevData) => [...prevData, ...response.data.result.mlgAccmlList]);
            }       
        }            
        
    };

    

    useEffect(() => {
        if(page > 0){        
            fetchData(1)  
        }
      }, [selectType]);

      useEffect(() => {
        if(page > 0){
            fetchData(page);    
        }
      }, [page]);

      const handleObserver = (entries) => {
        const target = entries[0];
        if (target.isIntersecting ) {
            setPage((prevPage) => prevPage + 1);
        }
      };
    
      useEffect(() => {
        const observer = new IntersectionObserver(handleObserver, {
          threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
        });
        // 최하단 요소를 관찰 대상으로 지정함
        const observerTarget = document.getElementById("observer");
        // 관찰 시작
        if (observerTarget) {
          observer.observe(observerTarget);
        }
      }, []);

    return(
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="search" pageTitle={t(`Message.discount_info_mlg`)}/>

            <div className="pl20 pr20">
                <div className="historyDate dfsb mt24">
                    <div className="dfcsG4">
                        <BsCalendar4Week className="mr4"/>
                        <p>{moment(srchStartDt).format('YYYY-MM-DD')}</p>
                        <span>~</span>
                        <p>{moment(srchEndDt).format('YYYY-MM-DD')}</p>
                    </div>
                    <div className="buttonArea">
                        <button type="button" 
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                setOpen(true);
                            }}
                            className="btn24 orgB cFFF">
                                {t(`Message.my_order_hist_list_set_period`)}
                        </button>
                    </div>
                </div>
            </div>




             

            <div className="mhWr">
                <Nav variant="tabs"  defaultActiveKey="all" onSelect={(select) => setSelectType(select==='all'?'':select) } className="tabType2" >                        
                    <Nav.Item>
                        <Nav.Link eventKey="all">{t(`Message.common_all`)}</Nav.Link>
                    </Nav.Item>
                    
                    <Nav.Item>
                        <Nav.Link eventKey="plus">적립</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="minus">사용</Nav.Link>
                    </Nav.Item>

                </Nav>  
                
                <div className="tabCont">
                    {dataList && dataList.length === 0?(
                    <div className="floatCenter">
                        <Nodata text={t(`마일리지 적립 및 사용 내역이 없습니다.`)}/>
                    </div> 
                    ):(
                    <>
                    {dataList && dataList.map((obj, index) => (
                    <div className="mileCont">                        
                        <div className="dfColG4">
                            <p className="date">{obj.accmlDt}</p>
                            <p className="tit">{obj.goodsNm?obj.goodsNm:obj.codeDc}</p>
                            <p className="bla">{obj.accmlTyCodeNm}</p>
                        </div>
                        <p className={"mileStatus "+obj.cdCn1}>{obj.accmlAmount.toLocaleString('ko-KR')} {t(`Message.discount_info_mlg`)}</p>
                    </div>
                    ))}   
                    </>
                    )}

                    <div id="observer" style={{ height: "10px" }}></div>
                </div>
            </div>



            <Sheet isOpen={isOpen} onClose={() => setOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 setDateModal">
                        <h3 className="btModalTit">{t(`Message.my_order_hist_list_set_period`)}</h3>
                        <ul className="dfcsG6 inputWr">
                            <li>
                                <Controller
                                    name={"srchStartDt"}                  
                                    control={control}                  
                                    rules={{  required:"필수 응답 항목입니다."  }}
                                    defaultValue={srchStartDt}
                                    render={({ field: { onChange } }) => {
                                        return (
                                        <DatePicker
                                            locale={ko}
                                            onChange={(date) =>{onChange(date); setSrchStartDt(date)}}
                                            selected={srchStartDt}
                                            dateFormat="yyyy-MM-dd"
                                            maxDate={srchEndDt}
                                            
                                        />
                                        );
                                    }}
                                />
                                <BsCalendar4Week/>
                            </li>
                            <li className="bd0">~</li>
                            <li>
                                <Controller
                                    name={"srchEndDt"}                  
                                    control={control}                  
                                    rules={{  required:"필수 응답 항목입니다."  }}
                                    defaultValue={srchEndDt}
                                    render={({ field: { onChange } }) => {
                                        return (
                                        <DatePicker
                                            locale={ko}
                                            onChange={(date) =>{onChange(date); setSrchEndDt(date)}}
                                            selected={srchEndDt}
                                            dateFormat="yyyy-MM-dd"
                                            minDate={srchStartDt}
                                        />
                                        );
                                    }}
                                />
                                <BsCalendar4Week/>
                            </li>
                        </ul>
                        <div className="radioWr dfcsG12">
                            <input type="radio" name="month" id="mon1" onChange={(e)=> fn_checkMonth(e)}  value="0" checked={month === '0'} />
                            <label htmlFor="mon1">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 1})}</label>
                            <input type="radio" name="month" id="mon3" onChange={(e)=> fn_checkMonth(e)}  value="1" checked={month === '1'}/>
                            <label htmlFor="mon3">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 3})}</label>
                            <input type="radio" name="month" id="mon6" onChange={(e)=> fn_checkMonth(e)}  value="2" checked={month === '2'}/>
                            <label htmlFor="mon6">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 6})}</label>
                            <input type="radio" name="month" id="mon12" onChange={(e)=> fn_checkMonth(e)}  value="3" checked={month === '3'}/>
                            <label htmlFor="mon12">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 12})}</label>
                        </div>
                    </div>
                    <div className="btnWr mt10">
                        <button type="button" className="btn40 wgB cDisa" onClick={() => setOpen(false)}>{t(`Message.common_cancel`)}</button>
                        <button type="button" className="btn40 orgB cFFF" onClick={() => {setOpen(false); fetchData(1)}}>변경</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)}/>
            </Sheet> 
        </div>
    )
}